import { render, staticRenderFns } from "./buyTips.vue?vue&type=template&id=309fba79&scoped=true&"
import script from "./buyTips.vue?vue&type=script&lang=js&"
export * from "./buyTips.vue?vue&type=script&lang=js&"
import style0 from "./buyTips.vue?vue&type=style&index=0&id=309fba79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309fba79",
  null
  
)

export default component.exports